import { render, staticRenderFns } from "./BasePriceBreakdown.vue?vue&type=template&id=317e2a38&"
import script from "./BasePriceBreakdown.vue?vue&type=script&lang=js&"
export * from "./BasePriceBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports